export default {
  'EventData.confirmHiring': {
    en: 'Confirm hiring',
    fr: "Confirmer l'embauche",
  },
  'EventData.musician': { en: 'Musician', fr: 'Musicien.ne' },
  'EventData.yourEvent': { en: 'Your Event', fr: 'Votre événement' },
};
